export const filterOutKeys = <T>(existingKeys: T[][], keysToFilter: T[][]): T[][] => {
  return existingKeys.filter(
    (oldKey) =>
      !keysToFilter.some(
        (newKey) =>
          newKey.length === oldKey.length &&
          newKey.every((value, index) => value === oldKey[index]),
      ),
  );
};
